// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\n  margin: 0px;\n  font-family: \"Helvetica\", \"Arial\", \"Verdana\", sans-serif;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 16px;\n}\nbody .root .tabPages {\n  margin: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
